/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import moment, {Moment} from 'moment';
import React from 'react';
import _ from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import UserConstants from 'constants/UserConstants';
import * as SpaceUtil from 'growth/SpaceUtil';
import OrganizationInvitesSection from 'orgs/OrganizationInvitesSection';
import preferences from 'Preferences';
import UpgradeAccountModal from 'start/upgrade-account/UpgradeAccountModal';
import EntityStore from 'stores/EntityStore';
import licenses from 'user/Licenses';

import {AcademicReferralBanner} from './ReferralBanners';
import UpgradeAccountBanner from './UpgradeAccountBanner';

const BANNER_KEYS = {
  ACADEMIC_REFERRAL: 'ACADEMIC_REFERRAL',
  UPGRADE_ACCOUNT: 'UPGRADE_ACCOUNT',
};

const BANNERS = {
  [BANNER_KEYS.ACADEMIC_REFERRAL]: {
    isEnabled: (currentUser: any) =>
      BenchlingConfig.ENABLE_USER_SIGNUPS &&
      BenchlingConfig.ENABLE_GLOBAL_INVITE_SCIENTISTS &&
      currentUser.status !== UserConstants.STATUS_GOLD &&
      !SpaceUtil.hasUnlimitedSpace(currentUser) &&
      !licenses.hasEnterprisePlan() &&
      moment().diff(moment(currentUser.joinedOn), 'days') >= 7,
    preferenceKey: 'bannerLastDismissed.referrals',
    bannerClass: AcademicReferralBanner,
  },
  [BANNER_KEYS.UPGRADE_ACCOUNT]: {
    isEnabled: (currentUser: any) => UpgradeAccountModal.isEnabled(currentUser),
    preferenceKey: 'bannerLastDismissed.upgradeAccount',
    bannerClass: UpgradeAccountBanner,
  },
};

export interface SidepanelNotificationsSectionProps {
  currentUser?: any;
}

type State = any;

class SidepanelNotificationsSection extends React.Component<SidepanelNotificationsSectionProps, State> {
  constructor(props: SidepanelNotificationsSectionProps) {
    super(props);
    let displayedBannerKey = null;
    const bannerKeyToLastDismissed: {[key: string]: Moment | null} = {};
    for (const bannerKey of Object.values(BANNER_KEYS)) {
      const lastDismissed = preferences.get(BANNERS[bannerKey].preferenceKey);
      const momentLastDismissed = lastDismissed ? moment(lastDismissed) : null;
      bannerKeyToLastDismissed[bannerKey] = momentLastDismissed;
    }
    // If any banners were dismissed in the past week, don't show any.
    const hasDismissedLastWeek = Object.values(bannerKeyToLastDismissed).some(
      (lastDismissed) => lastDismissed && lastDismissed.isAfter(moment().subtract(1, 'weeks'))
    );
    if (!hasDismissedLastWeek) {
      // Find a banner which hasn't been dismissed within the past 4 weeks.
      // eslint-disable-next-line no-restricted-syntax
      displayedBannerKey = _.find(Object.keys(bannerKeyToLastDismissed), (key) => {
        const lastDismissed = bannerKeyToLastDismissed[key];
        return (
          BANNERS[key].isEnabled(props.currentUser) &&
          (!lastDismissed || lastDismissed.isBefore(moment().subtract(4, 'weeks')))
        );
      });
    }

    this.state = {
      displayedBannerKey,
    };
  }

  _handleCloseBanner = (bannerKey: any): void => {
    preferences.set(BANNERS[bannerKey].preferenceKey, new Date().toISOString());
    this.setState({
      displayedBannerKey: null,
    });
  };

  render(): React.ReactNode {
    if (!this.props.currentUser) {
      return null;
    }

    if (EntityStore.currentUserHasPendingInvites()) {
      return <OrganizationInvitesSection className="homeSidepanel-notifications" />;
    }

    if (this.state.displayedBannerKey) {
      const BannerClass = BANNERS[this.state.displayedBannerKey].bannerClass;
      return (
        <BannerClass
          onCloseBanner={() => {
            this._handleCloseBanner(this.state.displayedBannerKey);
          }}
        />
      );
    }

    return null;
  }
}

export default SidepanelNotificationsSection;
